(function() {
  exports.mockService = function() {
    var mocked;
    mocked = null;
    inject(function($q) {
      return mocked = {
        _query: function(result) {
          var defer;
          defer = $q.defer();
          defer.resolve(result);
          return defer.promise;
        }
      };
    });
    return mocked;
  };

}).call(this);
